'use strict'
require('core-js/modules/es.array.filter')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.join')
require('core-js/modules/es.object.keys')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = void 0

var _is = require('../is')

function calcFromObj(obj) {
  return Object.keys(obj).filter(function(clName) {
    return obj[clName] === true
  })
}

function calcFromArr(arr) {
  var result = []
  arr.forEach(function(clDefinition) {
    if ((0, _is.isStr)(clDefinition) && clDefinition.length !== 0) {
      result.push(clDefinition)
    } else if ((0, _is.isObj)(clDefinition)) {
      result.push.apply(result, calcFromObj(clDefinition))
    }
  })

  return result
}

var join = function join(arr) {
  return arr.join(' ')
}

function calcClasses(cls) {
  if ((0, _is.isArr)(cls)) {
    return join(calcFromArr(cls))
  }
  if ((0, _is.isObj)(cls)) {
    return join(calcFromObj(cls))
  }
  return ''
}
var _default = calcClasses
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/react/calcClassesv2.js
// module id = 643
// module chunks = 0